// componente che espone la pagina e le funzioni di login

import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../../service/authentication.service';
import { ApiService } from '../../../service/api.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AlertService } from 'src/app/service/alert.service';

export interface DialogData {
  text: string;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginFormGroup: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error = '';
  id;
  mobHeight: any;
  mobWidth: any;
  constructor(private als: AlertService,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private router: Router, public dataStorageService: ApiService,
    private authenticationService: AuthenticationService
  ) {
    // se l'utente è già loggato viene reindirizzato nella pagina di gestione messaggi
    if (this.authenticationService.currentUserValue) {
      let agent = navigator.userAgent;
      agent = agent.toLowerCase()
      if (agent.includes("android") || agent.includes("iphone")) {
        this.router.navigate(['mobile']);
      } else {
        this.router.navigate(['']);
      }
    }
  }

  // le credenziali di accesso, mostrate nella loginform, sono impostate come obbligatorie (required)
  ngOnInit() {
    this.loginFormGroup = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });

    // impostazione del path da raggiungere in caso di login corretto (pagina di gestione messaggi)
    let agent = navigator.userAgent;
    agent = agent.toLowerCase()
    if (agent.includes("android") || agent.includes("iphone")) {
      this.returnUrl = 'mobile';
    } else {
      this.returnUrl = '';
    }
  }

  // metodo che restituisce le credenziali digitate dall'utente nell'apposito form di login
  get f() {
    return this.loginFormGroup.controls;
  }

  // metodo richiamato al click del pulsante "Login"
  onSubmit() {

    // la variabile di controllo "submitted" viene impostata a true
    this.submitted = true;

    // se la form non è valido (credenziali non digitate) si esce subito dalla funzione
    if (this.loginFormGroup.invalid) {
      return;
    }

    // la variabile di controllo "loading" viene impostata a true
    this.loading = true;

    // si richiama l'opportuno metodo di login dalla componente di autenticazione inserendo le credenziali digitate dall'utente
    this.authenticationService.login(this.f.username.value, this.f.password.value)
      .subscribe((data) => {

        // in caso di corretto login l'utente viene indirizzato nella pagina impostata in ngOnInit
        this.router.navigate([this.returnUrl]);
      },

        // in caso di login non corretto la variabile loading viene impostata a false e non c'è alcun reindirizzamento
        error => {
          this.loading = false;
        }
      );
  }

  // metodo richiamato al click del pulsante "Recupero credenziali"
  recover(): void {
    var me = this

    // viene aperto il pop-up col form di inserimento username/mail
    const dialogRef = this.dialog.open(Recov, {
      width: '500px',
      data: { id: this.id }
    });

    // alla chiusura del pop-up viene richiamato l'opportuno servizio di recupero mail
    dialogRef.afterClosed().subscribe(result => {
      if (!result) { return; }
      me.dataStorageService.recover(result.id).subscribe(value => {

        // alla ricezione di una risposta dal back-end viene mostrata una finestra di dialogo da far sparire digitando "ok"
        if (confirm(value)) { }
      });
    });
  }
}

// componente di recupero credenziali; permette di esporre il pop-up di inserimento username/mail tramite pagina recover.html
@Component({
  selector: 'recover',
  templateUrl: 'recover.html',
})
export class Recov implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<Recov>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }
  ngOnInit() {
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}
